module.exports = __webpack_public_path__ + "img/Icon-1.529a1c0c.png";